import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { BroadcastMessage } from '../models/BroadcastMessage';

@Injectable({
    providedIn: 'root'
})
export class BroadcastService {

  constructor() { }

  private handler: Subject<BroadcastMessage> = new Subject<BroadcastMessage>();

  public REFRESH_NOTIFICATIONS: string = 'REFRESH_NOTIFICATIONS';

  boradcast(message: BroadcastMessage) {
    this.handler.next(message);
  }

  subscribe(callback: (message: BroadcastMessage) => void): Subscription {
    return this.handler.subscribe(callback);
  } 
}